import React, {Component} from 'react';
import { PlusIcon, MinusIcon } from '@heroicons/react/solid';
import "./app.scss";
import i18next from 'i18next';
import ContactPage from "../contact/contact";
import contentCreatorImage from "../../assets/content-creator.png";
import corporateCommsImage from "../../assets/corporate-comms.png";
import marketingTeamsImage from "../../assets/marketing-teams.png";
import prProfessionalsImage from "../../assets/pr-professionals.png";


interface IProps {
	className?: string;
	id?: string;
	history?: any;
	signUp: (url: string) => void
}

export default class App extends Component<IProps, any> {

	state = {
		plan: "individual",
		activeFaq: "01",
	}

	updatePlan = (plan: string) => {
		this.setState({plan})
	}

	protected navigateToPricing() {
		const hash = this.props.history.location.hash;
		if (hash && hash == '#pricing') {
			const id = hash.replace('#', '');
			const element = document.getElementById(id);
			if (element) {
				element.scrollIntoView();
			}
		}
	}

	componentDidMount() {
		this.navigateToPricing()
	}

	componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<any>, snapshot?: any) {
		this.navigateToPricing()
	}

	public render() {
		return (
			<div className="App py-28">
				<div className="foreword mb-30 flex flex-col-reverse md:flex-row justify-between items-center w-full py-8">
					<div className="flex flex-col justify-start items-start space-y-6 md:w-1/2">
						<h1 className="text-5xl md:text-7xl break-keep font-medium  dark:!text-white">
							{i18next.t("One-Click Multi-Channel Publication")}
						</h1>
						<p className="text-xl md:text-2xl  dark:!text-gray-300">
							{i18next.t("Streamline your media workflows and publish via ActivityPub, Facebook, X, LinkedIn, and YouTube with a single click—no more fragmented tools or manual steps")}
						</p>
						<button className="px-8 py-3 rounded-2xl bg-clip-blue shadow-xl text-2xl text-white hover:bg-clip-blue">
							<a href="/app/signup">{i18next.t("Get Started for Free")}</a>
						</button>
					</div>
					<div>
						<img className={"w-[25rem]"}
						     src={"https://storage.googleapis.com/clipsymphony_static_assets/Illustration.png"}
						     alt={"landing page hero image"}/>
					</div>
				</div>

				<div className="flex flex-col my-28 w-full px-4 md:px-0">
					<div className="flex flex-col justify-start items-start">
						<div
							className="flex flex-col justify-start items-start gap-2.5 p-4 text-gray-800 dark:text-white">
							<p className="text-2xl md:text-4xl font-medium text-left">
								{i18next.t("Orchestrate All Your Channels in Harmony")}
							</p>
						</div>
					</div>
					<div className="flex flex-col justify-start items-start my-16 gap-10">
						<div className="grid md:grid-cols-2 items-start gap-10">
							<div className="flex h-auto shadow-lg flex-1 justify-between items-center w-full p-8 md:p-12 rounded-[45px] bg-gray-200 dark:bg-gray-200 border border-gray-900 dark:border-gray-400">
								<div className="flex flex-col justify-center items-start gap-9">
									<div className="flex flex-col justify-start items-start">
										<div
											className="flex flex-col justify-start items-start relative gap-2.5 px-2 rounded-lg">
											<p className="text-3xl break-all font-medium text-left">
												{i18next.t("Connect All Your Media Sources")}
											</p>
										</div>
									</div>
									<div className="flex justify-start items-center relative gap-4">
										<p className="text-xl text-left">
											{i18next.t("Aggregate RSS feeds, blogs, video channels, and social profiles in one centralized hub")}
										</p>
									</div>
								</div>
							</div>
							<div className="flex flex-1 shadow-lg h-auto justify-between items-center w-full p-8 md:p-12 rounded-[45px] bg-gray-900 dark:bg-gray-700 border border-gray-900 dark:border-gray-400">
								<div className="flex flex-col justify-start items-start gap-9">
									<div className="flex flex-col justify-start items-start">
										<div className="flex flex-col justify-start items-start relative gap-2.5 px-2 rounded-lg">
											<p className="text-3xl font-medium text-left !text-white">
												{i18next.t("Collaborate in Real Time")}
											</p>
										</div>
									</div>
									<div className="flex justify-start items-center relative gap-4">
										<p className="text-xl text-left !text-white">
											{i18next.t("Coordinate with your team through roles, approval workflows, and a shared editorial calendar")}
										</p>
									</div>
								</div>
							</div>
						</div>
						<div className="grid md:grid-cols-2 items-start gap-10">
							<div className="flex shadow-lg justify-between items-center w-full h-auto p-8 md:p-12 rounded-[45px] bg-clip-blue dark:bg-clip-blue border border-gray-900 dark:border-gray-400">
								<div className="flex flex-col justify-start items-start gap-9">
									<div className="flex flex-col justify-start items-start">
										<div className="flex flex-col justify-start items-start relative gap-2.5 px-2 rounded-lg">
											<p className="text-3xl font-medium text-left text-white">
												{i18next.t("Publish Everywhere with One Click")}
											</p>
										</div>
									</div>
									<p className="text-xl text-left text-white dark:!text-gray-300">
										{i18next.t("Publish content across federated networks, social media platforms with a single click")}
									</p>
								</div>
							</div>
							<div className="flex !hidden shadow justify-between items-center w-full h-auto p-8 md:p-12 rounded-[45px] bg-gray-100 dark:!bg-gray-800 border border-gray-900 dark:border-gray-400" style={{boxShadow: "0px 5px 0px 0 #191a23"}}>
								<div className="flex flex-col h-auto justify-center items-start gap-9">
									<div className="flex flex-col justify-start items-start">
										<div
											className="flex flex-col justify-start items-start relative gap-2.5 px-2 rounded-lg">
											<p className="text-3xl font-medium text-left  dark:!text-white">
												{i18next.t("Collaborate and Conquer")}
											</p>
										</div>
									</div>
									<div className="flex justify-start items-center relative gap-4">
										<p className="text-xl text-left  dark:!text-white">
											{i18next.t("Manage multiple teams and workspaces from a single platform")}<br/>
											{i18next.t("Assign roles and permissions to foster seamless collaboration")}
										</p>
									</div>
								</div>
							</div>
						</div>
						<div className="grid !hidden w-full h-auto md:grid-cols-2 items-start gap-10">
							<div
								className="flex shadow-lg justify-between items-center w-full h-auto p-8 md:p-12 rounded-[45px] bg-clip-blue dark:bg-clip-blue border border-gray-900 dark:border-gray-400">
								<div className="flex flex-col justify-start items-start gap-9">
									<div className="flex flex-col justify-start items-start">
										<div
											className="flex flex-col justify-start items-start relative gap-2.5 px-2 rounded-lg">
											<p className="text-3xl font-medium text-left !text-white">
												{i18next.t("Create, Export, Share")}
											</p>
										</div>
									</div>
									<div className="flex justify-start items-center relative gap-4">
										<p className="text-xl text-left !text-white">
											{i18next.t("Use our rich text editor to craft and customize engaging articles")}<br/>
											{i18next.t("Export and share collections in formats like RSS PDF XML and JSON")}
										</p>
									</div>
								</div>
							</div>
						</div>
						<div className="w-full h-auto mt-16">
							<div className="flex flex-col-reverse md:flex-row-reverse justify-center md:justify-between items-center px-8 py-4 md:p-12 md:py-2 rounded-[45px] space-x-0 bg-gray-100 dark:bg-gray-500">
								<div>
									<svg
										width={534}
										height={394}
										viewBox="0 0 534 394"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										className="w-80 h-60 relative"
										preserveAspectRatio="xMidYMid meet"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M90.916 162.915L140.014 191.262V202.6L90.916 230.947V219.608L130.194 196.931L90.9163 174.254L90.916 162.915Z"
											fill="#3F3D56"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M90.916 185.593L110.555 196.931L90.916 208.27V185.593Z"
											fill="#3F3D56"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M81.0977 162.916L32 191.262V202.6L71.2774 179.924V225.277L81.0977 230.947V162.916ZM61.459 196.932L41.8184 208.27L61.459 219.607V196.932Z"
											fill="#3F3D56"
										/>
										<path
											d="M263.227 166.35C261.56 166.35 260.274 166.827 259.369 167.779C258.464 168.684 258.012 169.849 258.012 171.277C258.012 172.706 258.464 173.873 259.369 174.777C260.274 175.634 261.56 176.062 263.227 176.062C264.893 176.062 266.225 175.634 267.225 174.777C268.224 173.92 268.725 172.753 268.725 171.277C268.725 169.801 268.224 168.612 267.225 167.707C266.225 166.802 264.893 166.35 263.227 166.35ZM307.178 166.35C305.511 166.35 304.227 166.827 303.322 167.779C302.418 168.684 301.965 169.849 301.965 171.277C301.965 172.706 302.418 173.873 303.322 174.777C304.227 175.634 305.511 176.062 307.178 176.062C308.844 176.062 310.178 175.634 311.178 174.777C312.178 173.92 312.678 172.753 312.678 171.277C312.678 169.801 312.178 168.612 311.178 167.707C310.178 166.802 308.844 166.35 307.178 166.35ZM188.716 166.707L174.218 217.059H183.146L186.073 205.773H197.859L200.929 217.059H210.357L195.786 166.707H188.716ZM247.428 171.992L238.93 174.635V181.348H235.002V188.918H238.93V207.631C238.93 211.345 239.597 213.987 240.93 215.559C242.31 217.13 244.358 217.914 247.072 217.914C248.596 217.914 250.047 217.725 251.428 217.344C252.809 217.01 254.023 216.582 255.07 216.059L254 209.273C253.333 209.559 252.714 209.773 252.143 209.916C251.571 210.059 250.927 210.131 250.213 210.131C249.165 210.131 248.429 209.701 248 208.844C247.619 207.987 247.428 206.536 247.428 204.488V188.918H254.355V181.348H247.428V171.992ZM327.66 171.992L319.162 174.635V181.348H315.232V188.918H319.162V207.631C319.162 211.345 319.827 213.987 321.16 215.559C322.541 217.13 324.589 217.914 327.303 217.914C328.826 217.914 330.279 217.725 331.66 217.344C333.041 217.01 334.255 216.582 335.303 216.059L334.23 209.273C333.564 209.559 332.944 209.773 332.373 209.916C331.802 210.059 331.16 210.131 330.445 210.131C329.398 210.131 328.661 209.701 328.232 208.844C327.852 207.987 327.66 206.536 327.66 204.488V188.918H334.588V181.348H327.66V171.992ZM192.001 178.848H192.286L193.431 186.705L196.286 198.346H188.003L190.788 186.775L192.001 178.848ZM223.947 180.42C219.615 180.42 216.328 181.99 214.09 185.133C211.852 188.275 210.734 192.966 210.734 199.203C210.734 202.06 210.948 204.655 211.377 206.988C211.853 209.274 212.615 211.25 213.662 212.916C214.71 214.535 216.043 215.797 217.662 216.701C219.329 217.558 221.374 217.986 223.803 217.986C225.469 217.986 227.136 217.748 228.803 217.271C230.469 216.795 231.898 216.081 233.088 215.129L231.303 208.559C230.589 209.035 229.802 209.44 228.945 209.773C228.136 210.059 227.136 210.201 225.945 210.201C223.708 210.201 222.065 209.178 221.018 207.131C220.018 205.084 219.518 202.441 219.518 199.203C219.518 195.347 220.018 192.562 221.018 190.848C222.017 189.086 223.518 188.205 225.518 188.205C226.613 188.205 227.541 188.322 228.303 188.561C229.112 188.751 229.946 189.062 230.803 189.49L232.803 182.42C231.755 181.849 230.541 181.371 229.16 180.99C227.827 180.609 226.09 180.42 223.947 180.42ZM259.012 181.348V217.059H267.512V181.348H259.012ZM270.066 181.348L282.709 217.414H288.422L300.42 181.348H291.279L286.852 199.918L286.064 205.631H285.779L284.922 199.988L279.994 181.348H270.066ZM302.965 181.348V217.059H311.463V181.348H302.965ZM336.496 181.348L348.924 217.059C348.638 218.63 348.28 219.891 347.852 220.844C347.423 221.796 346.923 222.486 346.352 222.914C345.828 223.39 345.233 223.629 344.566 223.629C343.947 223.677 343.328 223.58 342.709 223.342L341.281 230.627C341.948 231.008 342.734 231.269 343.639 231.412C344.591 231.603 345.567 231.699 346.566 231.699C347.995 231.699 349.209 231.269 350.209 230.412C351.256 229.603 352.185 228.413 352.994 226.842C353.804 225.271 354.565 223.367 355.279 221.129C355.993 218.891 356.755 216.368 357.564 213.559L366.492 181.348H357.779L353.637 201.346L352.994 206.988H352.637L351.709 201.416L346.709 181.348H336.496Z"
											fill="#3F3D56"
										/>
										<path
											d="M386.908 166.35C384.861 166.35 382.813 166.469 380.766 166.707C378.718 166.897 376.839 167.184 375.125 167.564V217.059H384.123V199.846C384.313 199.893 384.622 199.941 385.051 199.988L386.48 200.131H387.838H388.766C390.813 200.131 392.789 199.822 394.693 199.203C396.645 198.584 398.36 197.584 399.836 196.203C401.312 194.822 402.477 193.038 403.334 190.848C404.239 188.657 404.691 185.99 404.691 182.848C404.691 179.372 404.169 176.562 403.121 174.42C402.074 172.23 400.715 170.54 399.049 169.35C397.382 168.159 395.478 167.373 393.336 166.992C391.241 166.564 389.098 166.35 386.908 166.35ZM438.633 167.064V215.629C439.776 216.2 441.393 216.725 443.488 217.201C445.631 217.677 447.965 217.914 450.488 217.914C455.107 217.914 458.748 216.344 461.414 213.201C464.08 210.011 465.414 205.036 465.414 198.275C465.414 192.038 464.461 187.514 462.557 184.705C460.7 181.896 458.082 180.49 454.701 180.49C451.511 180.49 449.06 181.538 447.346 183.633H447.131V167.064H438.633ZM387.766 174.35C388.765 174.35 389.718 174.492 390.623 174.777C391.528 175.063 392.312 175.539 392.979 176.205C393.693 176.824 394.24 177.682 394.621 178.777C395.05 179.872 395.264 181.206 395.264 182.777C395.264 184.634 395.05 186.18 394.621 187.418C394.193 188.608 393.598 189.561 392.836 190.275C392.122 190.942 391.288 191.417 390.336 191.703C389.384 191.989 388.385 192.133 387.338 192.133C387.052 192.133 386.505 192.108 385.695 192.061C384.934 191.965 384.409 191.871 384.123 191.775V174.707C385.075 174.469 386.29 174.35 387.766 174.35ZM408.084 181.348V204.559C408.084 207.225 408.298 209.44 408.727 211.201C409.155 212.915 409.773 214.272 410.582 215.271C411.391 216.271 412.369 216.963 413.512 217.344C414.654 217.772 415.963 217.986 417.439 217.986C419.725 217.986 421.629 217.439 423.152 216.344C424.724 215.249 425.963 213.868 426.867 212.201H427.08L428.58 217.059H435.008C434.627 215.535 434.365 213.843 434.223 211.986C434.08 210.082 434.008 208.153 434.008 206.201V181.348H425.51V205.201C425.129 206.582 424.485 207.774 423.58 208.773C422.675 209.726 421.558 210.201 420.225 210.201C418.844 210.201 417.891 209.654 417.367 208.559C416.843 207.464 416.582 205.512 416.582 202.703V181.348H408.084ZM451.916 188.275C453.535 188.275 454.725 189.134 455.486 190.848C456.248 192.514 456.629 195.155 456.629 198.773C456.629 202.868 456.153 205.797 455.201 207.559C454.249 209.273 452.868 210.131 451.059 210.131C449.44 210.131 448.131 209.867 447.131 209.344V191.99C447.94 189.514 449.535 188.275 451.916 188.275Z"
											fill="#3F3D56"
										/>
									</svg>
								</div>
								<div className="flex justify-start items-center w-full text-left h-auto gap-10">
									<div className="flex flex-col gap-3">
										<p className="text-3xl font-medium md:text-left  dark:!text-white">
											{i18next.t("Reach Decentralized Networks via ActivityPub")}
										</p>
										<p className="text-lg dark:!text-gray-300">
											{i18next.t("Seamlessly integrate with ActivityPub to syndicate your content across Mastodon, Friendica, Pleroma, and more")}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="flex !hidden flex-col my-28 w-full px-4 md:px-0">
					<div className="flex flex-col justify-start items-start">
						<div className="flex flex-col justify-start items-start gap-2.5 p-4 text-gray-800 dark:text-white">
							<p className="text-2xl md:text-4xl font-medium text-left dark:!text-white">
								{i18next.t("AI-Driven Efficiency")}
							</p>
						</div>
					</div>
					<div className="flex flex-col justify-start items-start py-10">
						<div
							className="flex flex-col md:flex-row justify-start items-start gap-16 px-4 md:px-16 py-16 rounded-[45px] bg-gray-900 dark:bg-gray-800">
							<div className="flex flex-col justify-start items-start gap-5">
								<p className="text-lg text-left text-white">
          <span className="font-bold">
            {i18next.t("Content Generation & Writing Assistance")}
          </span>
									<br/><br/>
									{i18next.t("Leverage AI to swiftly generate quality content and get instant writing suggestions to enhance your articles")}
								</p>
							</div>
							<svg width={1} height={186} viewBox="0 0 1 186" fill="none" xmlns="http://www.w3.org/2000/svg"
							     className="hidden md:block">
								<line x1="0.5" y1="0" x2="0.5" y2={186} stroke="white"/>
							</svg>
							<div className="flex flex-col justify-start items-start gap-5">
								<p className="text-lg text-left text-white">
          <span className="font-bold">
            {i18next.t("Smart Formatting")}
          </span>
									<br/><br/>
									{i18next.t("Automatically format your documents as you type making content creation faster and more efficient")}
								</p>
							</div>
							<svg width={1} height={186} viewBox="0 0 1 186" fill="none" xmlns="http://www.w3.org/2000/svg"
							     className="hidden md:block">
								<line x1="0.5" y1="0" x2="0.5" y2={186} stroke="white"/>
							</svg>
							<div className="flex flex-col justify-start items-start gap-5">
								<p className="text-lg text-left text-white">
          <span className="font-bold">
            {i18next.t("Multilingual Support & Translation")}
          </span>
									<br/><br/>
									{i18next.t("Instantly translate your content into multiple languages using AI facilitating seamless global collaboration")}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="flex flex-col my-28 w-full px-4 md:px-0">
					<div className="flex flex-col justify-start items-start">
						<div
							className="flex flex-col justify-start items-start gap-2.5 p-4 text-gray-800 dark:text-white">
							<p className="text-2xl md:text-4xl font-medium text-left  dark:!text-white">
								{i18next.t("Who Benefits from ClipSymphony")}
							</p>
						</div>
					</div>
					<div className="flex flex-col justify-start items-start py-10">
						<div
							className="flex flex-col lg:flex-row justify-center md:justify-between items-center w-full mt-10  rounded-[45px] bg-gray-100 dark:bg-gray-800">
							<div
								className="flex justify-start items-center w-full lg:w-[50%] h-auto  gap-10  px-6 md:px-16 py-8 lg:py-0">
								<div className="flex flex-col justify-start items-start gap-6">
									<p className="text-3xl font-medium text-left dark:!text-white">
										{i18next.t("Content Creators")}
									</p>
									<p className="text-lg text-left dark:!text-gray-300">
										{i18next.t("Centralize your channels, accelerate content delivery, and grow your audience")}
									</p>
								</div>
							</div>
							<img src={contentCreatorImage} className={"w-full sm:w-[50%] sm:h-[50%] h-full"} alt={"content creator image"}/>
						</div>

						<div
							className="flex flex-col lg:flex-row-reverse justify-center md:justify-between items-center w-full mt-10  rounded-[45px] bg-gray-100 dark:bg-gray-800">
							<div
								className="flex justify-start items-center w-full lg:w-[50%] h-auto  gap-10  px-6 md:px-16 py-8 lg:py-0">
								<div className="flex flex-col justify-start items-start gap-6">
									<p className="text-3xl font-medium text-left  dark:!text-white">
										{i18next.t("PR Professionals")}
									</p>
									<p className="text-lg text-left  dark:!text-gray-300">
										{i18next.t("Manage campaigns, oversee brand reputation, and coordinate multi-channel outreach")}
									</p>
								</div>
							</div>
							<img src={prProfessionalsImage} className={"w-full h-full sm:w-[50%] sm:h-[50%]"} alt={"PR professionals image"}/>
						</div>

						<div
							className="flex flex-col lg:flex-row justify-center md:justify-between items-center w-full mt-10 rounded-[45px] bg-gray-100 dark:bg-gray-800">
							<div
								className="flex justify-start items-center w-full lg:w-[50%] h-auto gap-10 px-6 md:px-16 py-8 lg:py-0">
								<div className="flex flex-col justify-start items-start gap-6">
									<p className="text-3xl font-medium text-left  dark:!text-white">
										{i18next.t("Marketing Teams")}
									</p>
									<p className="text-lg text-left  dark:!text-gray-300">
										{i18next.t("Enhance your content strategy with easy collaboration and powerful creation tools")}
									</p>
								</div>
							</div>
							<img src={marketingTeamsImage} className={"w-full h-full sm:w-[50%] sm:h-[50%]"} alt={"marketing teams image"}/>
						</div>

						<div
							className="flex flex-col lg:flex-row-reverse justify-center md:justify-between items-center space-y-10 w-full rounded-[45px] bg-gray-100 dark:bg-gray-800 mt-10">
							<div
								className="flex justify-start items-center w-full lg:w-[50%] h-auto gap-10 px-6 md:px-16 py-8 lg:py-0">
								<div className="flex flex-col justify-start items-start gap-6">
									<p className="text-3xl break-all font-medium text-left  dark:!text-white">
										{i18next.t("Corporate Communications")}
									</p>
									<p className="text-lg text-left  dark:!text-gray-300">
										{i18next.t("Improve internal and external communications with efficient content sharing and team management")}
									</p>
								</div>
							</div>
							<img src={corporateCommsImage} className={"w-full h-full sm:w-[50%] sm:h-[50%]"} alt={"corporate communications image"}/>
						</div>
					</div>
				</div>

				<div id={"pricing"} className="flex flex-col my-28 w-full px-4 md:px-0">
					<div className="flex flex-col justify-start items-start">
						<div className="flex flex-col justify-start items-start gap-2.5 p-4 text-gray-800 dark:text-white">
							<p className="text-2xl md:text-4xl font-medium text-left dark:!text-white">
								{i18next.t("Choose the Plan Thats Right for You")}
							</p>
						</div>
					</div>
					<div className="flex justify-center items-center mt-10">
						<div
							onClick={(e: any) => {
								this.updatePlan("individual")
							}}
							className={`flex justify-center items-center h-16 px-8 py-5 rounded-l-lg border dark:border-gray-700 ${this.state.plan === "individual" ? "bg-clip text-white" : "dark:text-white"}`}>
							<p className="text-xl cursor-pointer text-center">{i18next.t("Individual")}</p>
						</div>
						<div
							onClick={(e: any) => {
								this.updatePlan("team")
							}}
							className={`flex justify-center items-center h-16 px-8 py-5 rounded-r-lg border dark:border-gray-700 ${this.state.plan === "team" ? "bg-clip text-white" : "dark:text-white"}`}>
							<p className="text-xl cursor-pointer text-center">{i18next.t("Team")}</p>
						</div>
					</div>
					<div className="flex justify-center items-center py-10">
						{
							this.state.plan === "individual" &&
							<div
								className="flex flex-col justify-between items-start w-full p-8 md:p-12 rounded-[45px] bg-gray-100 dark:bg-gray-800 border border-black dark:border-gray-700">
								<div className="flex flex-col gap-4">
									<h2 className="text-4xl font-bold dark:!text-white">
										{i18next.t("Basic Plan")}
									</h2>
									<p className="text-lg dark:!text-gray-300">
										{i18next.t("Ideal for Individuals")}
									</p>
								</div>
								<ul className="mt-6 space-y-4">
									<li className="flex items-center">
										<svg
											width={15}
											height={15}
											viewBox="0 0 15 15"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											className="w-4 h-4 dark:text-white"
										>
											<path
												d="M14.9051 2.53138L13.0504 0.482025C12.9881 0.413195 12.9035 0.374512 12.8153 0.374512C12.727 0.374512 12.6424 0.413195 12.5801 0.482025L4.7471 9.1186C4.68479 9.18743 4.60019 9.22612 4.51195 9.22612C4.42372 9.22612 4.33912 9.18743 4.2768 9.1186L2.42217 7.06925C2.35986 7.00042 2.27526 6.96173 2.18702 6.96173C2.09879 6.96173 2.01419 7.00042 1.95187 7.06925L0.097244 9.1186C-0.0324147 9.26151 -0.0324147 9.49316 0.097244 9.63607L4.2768 14.242C4.33912 14.3108 4.42372 14.3495 4.51195 14.3495C4.60019 14.3495 4.68479 14.3108 4.7471 14.242L14.9051 3.04372C15.0316 2.90142 15.0316 2.67368 14.9051 2.53138Z"
												fill="currentColor"
											/>
										</svg>
										<span className="ml-2 text-lg dark:text-white">
            {i18next.t("Free for personal use")}
          </span>
									</li>
									<li className="flex items-center">
										<svg
											width={15}
											height={15}
											viewBox="0 0 15 15"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											className="w-4 h-4 dark:text-white"
										>
											<path
												d="M14.9051 2.53138L13.0504 0.482025C12.9881 0.413195 12.9035 0.374512 12.8153 0.374512C12.727 0.374512 12.6424 0.413195 12.5801 0.482025L4.7471 9.1186C4.68479 9.18743 4.60019 9.22612 4.51195 9.22612C4.42372 9.22612 4.33912 9.18743 4.2768 9.1186L2.42217 7.06925C2.35986 7.00042 2.27526 6.96173 2.18702 6.96173C2.09879 6.96173 2.01419 7.00042 1.95187 7.06925L0.097244 9.1186C-0.0324147 9.26151 -0.0324147 9.49316 0.097244 9.63607L4.2768 14.242C4.33912 14.3108 4.42372 14.3495 4.51195 14.3495C4.60019 14.3495 4.68479 14.3108 4.7471 14.242L14.9051 3.04372C15.0316 2.90142 15.0316 2.67368 14.9051 2.53138Z"
												fill="currentColor"
											/>
										</svg>
										<span className="ml-2 text-lg dark:text-white">
            {i18next.t("2 GB free then €025 per GBmonth")}
          </span>
									</li>
									<li className="flex items-center">
										<svg
											width={15}
											height={15}
											viewBox="0 0 15 15"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											className="w-4 h-4 dark:text-white"
										>
											<path
												d="M14.9051 2.53138L13.0504 0.482025C12.9881 0.413195 12.9035 0.374512 12.8153 0.374512C12.727 0.374512 12.6424 0.413195 12.5801 0.482025L4.7471 9.1186C4.68479 9.18743 4.60019 9.22612 4.51195 9.22612C4.42372 9.22612 4.33912 9.18743 4.2768 9.1186L2.42217 7.06925C2.35986 7.00042 2.27526 6.96173 2.18702 6.96173C2.09879 6.96173 2.01419 7.00042 1.95187 7.06925L0.097244 9.1186C-0.0324147 9.26151 -0.0324147 9.49316 0.097244 9.63607L4.2768 14.242C4.33912 14.3108 4.42372 14.3495 4.51195 14.3495C4.60019 14.3495 4.68479 14.3108 4.7471 14.242L14.9051 3.04372C15.0316 2.90142 15.0316 2.67368 14.9051 2.53138Z"
												fill="currentColor"
											/>
										</svg>
										<span className="ml-2 text-lg dark:text-white">
            {i18next.t("Access to core functionalities")}
          </span>
									</li>
									<li className="flex items-center">
										<svg
											width={15}
											height={15}
											viewBox="0 0 15 15"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											className="w-4 h-4 dark:text-white"
										>
											<path
												d="M14.9051 2.53138L13.0504 0.482025C12.9881 0.413195 12.9035 0.374512 12.8153 0.374512C12.727 0.374512 12.6424 0.413195 12.5801 0.482025L4.7471 9.1186C4.68479 9.18743 4.60019 9.22612 4.51195 9.22612C4.42372 9.22612 4.33912 9.18743 4.2768 9.1186L2.42217 7.06925C2.35986 7.00042 2.27526 6.96173 2.18702 6.96173C2.09879 6.96173 2.01419 7.00042 1.95187 7.06925L0.097244 9.1186C-0.0324147 9.26151 -0.0324147 9.49316 0.097244 9.63607L4.2768 14.242C4.33912 14.3108 4.42372 14.3495 4.51195 14.3495C4.60019 14.3495 4.68479 14.3108 4.7471 14.242L14.9051 3.04372C15.0316 2.90142 15.0316 2.67368 14.9051 2.53138Z"
												fill="currentColor"
											/>
										</svg>
										<span className="ml-2 text-lg dark:text-white">
            {i18next.t("Single-user access")}
          </span>
									</li>
								</ul>
								<button className="mt-6 px-8 py-4 rounded-lg bg-clip text-white text-sm font-bold">
									<a href={"/app/signup?plan=individual"}> {i18next.t("Sign Up Risk-Free")} </a>
								</button>
							</div>
						}
					</div>
					{
						this.state.plan === "team" &&
						<div className="flex relative w-full justify-between items-center px-4 md:p-[50px] rounded-[45px] bg-gray-100 dark:bg-gray-800 border border-[#191a23]">
							<div className="relative flex-col space-y-8 w-full">
								<div className={"relative lg:flex lg:flex-row flex-col space-y-4 lg:space-y-0 w-full justify-between items-start"}>
									<div className="rounded-[20px] dark:text-white">
										<div className="">
											<svg
												width={72}
												height={72}
												viewBox="0 0 72 72"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												className="w-[72px] h-[72px] text-black dark:!text-white"
												preserveAspectRatio="xMidYMid meet"
											>
												<path
													d="M29.025 41.1L31.65 32.55L24.75 27H33.3L36 18.6L38.7 27H47.25L40.275 32.55L42.9 41.1L36 35.775L29.025 41.1ZM18 69V45.825C16.1 43.725 14.625 41.325 13.575 38.625C12.525 35.925 12 33.05 12 30C12 23.3 14.325 17.625 18.975 12.975C23.625 8.325 29.3 6 36 6C42.7 6 48.375 8.325 53.025 12.975C57.675 17.625 60 23.3 60 30C60 33.05 59.475 35.925 58.425 38.625C57.375 41.325 55.9 43.725 54 45.825V69L36 63L18 69ZM36 48C41 48 45.25 46.25 48.75 42.75C52.25 39.25 54 35 54 30C54 25 52.25 20.75 48.75 17.25C45.25 13.75 41 12 36 12C31 12 26.75 13.75 23.25 17.25C19.75 20.75 18 25 18 30C18 35 19.75 39.25 23.25 42.75C26.75 46.25 31 48 36 48Z"
													fill={localStorage.darkMode === "true" ? "white" : "black"}
												/>
											</svg>
											<p className="text-[32px] font-bold text-left ">
												<span className="text-[32px] font-bold text-left ">{i18next.t("30-days")}</span>
												<br/>
												<span className="text-[32px] font-bold text-left ">{i18next.t("Free Trial")}</span>
											</p>
										</div>
									</div>
									<div className="rounded-[20px] bg-white dark:text-white shadow dark:bg-gray-700 p-4">
										<div className="relative">
											<div className="rounded-[7px] !bg-black inline-block">
												<p className="text-sm py-1 px-2 font-bold text-center text-white">
													{i18next.t("Most Popular")}
												</p>
											</div>
											<p className="text-[30px] sm:text-[40px] font-bold text-left ">
												{i18next.t("Professional Plan")}
											</p>
											<p className="text-[15px] text-left ">
												{i18next.t("Perfect for Small Businesses and Startups")}
											</p>
											<br/>
											<br/>
											<div className="flex space-x-2 mb-2 items-center">
												<svg
													width={15}
													height={13}
													viewBox="0 0 15 13"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													className="w-[15px] h-[13px]"
													preserveAspectRatio="none"
												>
													<path
														d="M14.9051 2.00639L13.0504 0.100013C12.9881 0.0359843 12.9035 0 12.8153 0C12.727 0 12.6424 0.0359843 12.5801 0.100013L4.7471 8.13404C4.68479 8.19807 4.60019 8.23405 4.51195 8.23405C4.42372 8.23405 4.33912 8.19807 4.2768 8.13404L2.42217 6.22766C2.35986 6.16363 2.27526 6.12765 2.18702 6.12765C2.09879 6.12765 2.01419 6.16363 1.95187 6.22766L0.097244 8.13404C-0.0324147 8.26697 -0.0324147 8.48246 0.097244 8.6154L4.2768 12.9C4.33912 12.964 4.42372 13 4.51195 13C4.60019 13 4.68479 12.964 4.7471 12.9L14.9051 2.48299C15.0316 2.35061 15.0316 2.13876 14.9051 2.00639Z"
														fill="black"
													/>
												</svg>
												<p className="text-[15px] text-left ">
													{i18next.t("Unlimited Workspaces")}
												</p>
											</div>
											<div className="flex space-x-2 mb-2 items-center">
												<svg
													width={15}
													height={13}
													viewBox="0 0 15 13"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													className="w-[15px] h-[13px]"
													preserveAspectRatio="none"
												>
													<path
														d="M14.9051 2.00639L13.0504 0.100013C12.9881 0.0359843 12.9035 0 12.8153 0C12.727 0 12.6424 0.0359843 12.5801 0.100013L4.7471 8.13404C4.68479 8.19807 4.60019 8.23405 4.51195 8.23405C4.42372 8.23405 4.33912 8.19807 4.2768 8.13404L2.42217 6.22766C2.35986 6.16363 2.27526 6.12765 2.18702 6.12765C2.09879 6.12765 2.01419 6.16363 1.95187 6.22766L0.097244 8.13404C-0.0324147 8.26697 -0.0324147 8.48246 0.097244 8.6154L4.2768 12.9C4.33912 12.964 4.42372 13 4.51195 13C4.60019 13 4.68479 12.964 4.7471 12.9L14.9051 2.48299C15.0316 2.35061 15.0316 2.13876 14.9051 2.00639Z"
														fill="black"
													/>
												</svg>
  										<p className="text-[15px] text-left ">
  											{i18next.t("€89 per active usermonth")}
  										</p>
											</div>
											<div className="flex space-x-2 mb-2 items-center">
												<svg
													width={15}
													height={13}
													viewBox="0 0 15 13"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													className="w-[15px] h-[13px]"
													preserveAspectRatio="none"
												>
													<path
														d="M14.9051 2.00639L13.0504 0.100013C12.9881 0.0359843 12.9035 0 12.8153 0C12.727 0 12.6424 0.0359843 12.5801 0.100013L4.7471 8.13404C4.68479 8.19807 4.60019 8.23405 4.51195 8.23405C4.42372 8.23405 4.33912 8.19807 4.2768 8.13404L2.42217 6.22766C2.35986 6.16363 2.27526 6.12765 2.18702 6.12765C2.09879 6.12765 2.01419 6.16363 1.95187 6.22766L0.097244 8.13404C-0.0324147 8.26697 -0.0324147 8.48246 0.097244 8.6154L4.2768 12.9C4.33912 12.964 4.42372 13 4.51195 13C4.60019 13 4.68479 12.964 4.7471 12.9L14.9051 2.48299C15.0316 2.35061 15.0316 2.13876 14.9051 2.00639Z"
														fill="black"
													/>
												</svg>
												<p className="text-left ">
													{i18next.t("2 GB free then €025 per GBmonth")}
												</p>
											</div>
											<br/>
											<div className=" cursor-pointer">
												<div className="rounded-lg !bg-clip">
													<p className="text-sm font-bold p-4 text-center text-white">
														<a href={"/app/signup?plan=business"}> {i18next.t("Start Your Free Trial")} </a>
													</p>
												</div>
											</div>
										</div>
									</div>
									<div className="rounded-[20px] bg-white dark:text-white shadow dark:bg-gray-700 p-4">
										<div>
											<p className="text-[30px] sm:text-[40px] font-bold text-left ">
												{i18next.t("Enterprise Plan")}
											</p>
											<p className="text-[15px] text-left ">
												{i18next.t("Designed for Enterprises and Corporations")}
											</p>
											<br/>
											<br/>
											<div className="flex space-x-2 mb-2 items-center">
												<svg
													width={15}
													height={13}
													viewBox="0 0 15 13"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													className="w-[15px] h-[13px]"
													preserveAspectRatio="none"
												>
													<path
														d="M14.9051 2.00639L13.0504 0.100013C12.9881 0.0359843 12.9035 0 12.8153 0C12.727 0 12.6424 0.0359843 12.5801 0.100013L4.7471 8.13404C4.68479 8.19807 4.60019 8.23405 4.51195 8.23405C4.42372 8.23405 4.33912 8.19807 4.2768 8.13404L2.42217 6.22766C2.35986 6.16363 2.27526 6.12765 2.18702 6.12765C2.09879 6.12765 2.01419 6.16363 1.95187 6.22766L0.097244 8.13404C-0.0324147 8.26697 -0.0324147 8.48246 0.097244 8.6154L4.2768 12.9C4.33912 12.964 4.42372 13 4.51195 13C4.60019 13 4.68479 12.964 4.7471 12.9L14.9051 2.48299C15.0316 2.35061 15.0316 2.13876 14.9051 2.00639Z"
														fill="black"
													/>
												</svg>
												<p className="text-[15px] text-left ">
													{i18next.t("Everything in Professional Plan")}
												</p>
											</div>
											<div className="flex space-x-2 mb-2 items-center">
												<svg
													width={15}
													height={13}
													viewBox="0 0 15 13"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													className="w-[15px] h-[13px]"
													preserveAspectRatio="none"
												>
													<path
														d="M14.9051 2.00639L13.0504 0.100013C12.9881 0.0359843 12.9035 0 12.8153 0C12.727 0 12.6424 0.0359843 12.5801 0.100013L4.7471 8.13404C4.68479 8.19807 4.60019 8.23405 4.51195 8.23405C4.42372 8.23405 4.33912 8.19807 4.2768 8.13404L2.42217 6.22766C2.35986 6.16363 2.27526 6.12765 2.18702 6.12765C2.09879 6.12765 2.01419 6.16363 1.95187 6.22766L0.097244 8.13404C-0.0324147 8.26697 -0.0324147 8.48246 0.097244 8.6154L4.2768 12.9C4.33912 12.964 4.42372 13 4.51195 13C4.60019 13 4.68479 12.964 4.7471 12.9L14.9051 2.48299C15.0316 2.35061 15.0316 2.13876 14.9051 2.00639Z"
														fill="black"
													/>
												</svg>
												<p className="text-[15px] text-left ">
													{i18next.t("Minimum of 20 active users")}
												</p>
											</div>
											<div className="!hidden space-x-2 mb-2 items-center">
												<svg
													width={15}
													height={13}
													viewBox="0 0 15 13"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													className="w-[15px] h-[13px]"
													preserveAspectRatio="none"
												>
													<path
														d="M14.9051 2.00639L13.0504 0.100013C12.9881 0.0359843 12.9035 0 12.8153 0C12.727 0 12.6424 0.0359843 12.5801 0.100013L4.7471 8.13404C4.68479 8.19807 4.60019 8.23405 4.51195 8.23405C4.42372 8.23405 4.33912 8.19807 4.2768 8.13404L2.42217 6.22766C2.35986 6.16363 2.27526 6.12765 2.18702 6.12765C2.09879 6.12765 2.01419 6.16363 1.95187 6.22766L0.097244 8.13404C-0.0324147 8.26697 -0.0324147 8.48246 0.097244 8.6154L4.2768 12.9C4.33912 12.964 4.42372 13 4.51195 13C4.60019 13 4.68479 12.964 4.7471 12.9L14.9051 2.48299C15.0316 2.35061 15.0316 2.13876 14.9051 2.00639Z"
														fill="black"
													/>
												</svg>
												<p className="text-[15px] text-left ">
													{i18next.t("Bank transfer payment options")}
												</p>
											</div>
											<div className="flex space-x-2 mb-2 items-center">
												<svg
													width={15}
													height={13}
													viewBox="0 0 15 13"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													className="w-[15px] h-[13px]"
													preserveAspectRatio="none"
												>
													<path
														d="M14.9051 2.00639L13.0504 0.100013C12.9881 0.0359843 12.9035 0 12.8153 0C12.727 0 12.6424 0.0359843 12.5801 0.100013L4.7471 8.13404C4.68479 8.19807 4.60019 8.23405 4.51195 8.23405C4.42372 8.23405 4.33912 8.19807 4.2768 8.13404L2.42217 6.22766C2.35986 6.16363 2.27526 6.12765 2.18702 6.12765C2.09879 6.12765 2.01419 6.16363 1.95187 6.22766L0.097244 8.13404C-0.0324147 8.26697 -0.0324147 8.48246 0.097244 8.6154L4.2768 12.9C4.33912 12.964 4.42372 13 4.51195 13C4.60019 13 4.68479 12.964 4.7471 12.9L14.9051 2.48299C15.0316 2.35061 15.0316 2.13876 14.9051 2.00639Z"
														fill="black"
													/>
												</svg>
												<p className="text-[15px] text-left ">
													{i18next.t("Dedicated account manager")}
												</p>
											</div>
											<br/>
											<div className="">
												<p className="text-sm font-bold cursor-pointer p-4 rounded-lg bg-clip text-center text-white">
													<a href={"/app/contact-sales?plan=enterprise"}>{i18next.t("Contact Sales")}</a>
												</p>
											</div>
										</div>
									</div>
								</div>
								<div className="break-all">
									<div className={"grid grid-cols-[0.7fr_1fr_1fr] mb-2 justify-between items-center w-full dark:text-white"}>
										<div/>
										<p className="text-xl font-bold flex justify-center">
											{i18next.t("Professional")}
										</p>
										<p className="text-xl font-bold flex justify-center">
											{i18next.t("Enterprise")}
										</p>
									</div>
									<div className={"grid grid-cols-[0.7fr_1fr_1fr] mb-2 bg-white dark:text-white dark:bg-gray-700 p-4 justify-between w-full"}>
										<div>
											<p className="text-[15px] font-bold text-left ">
            <span className="text-[15px] font-bold text-left ">
              {i18next.t("Enhanced collaboration tools")}
            </span>
											</p>
										</div>
										<p className="text-xl font-bold flex justify-center ">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
												<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd"/>
											</svg>
										</p>
										<p className="text-xl font-bold flex justify-center ">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
												<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd"/>
											</svg>
										</p>
									</div>
									<div className={"grid grid-cols-[0.7fr_1fr_1fr] mb-2 p-4 dark:text-white justify-between items-center w-full"}>
										<div>
											<p className="text-[15px] font-bold text-left ">
												{i18next.t("Unlimited Workspaces")}
											</p>
										</div>
										<p className="text-xl font-bold flex justify-center ">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
												<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd"/>
											</svg>
										</p>
										<p className="text-xl font-bold flex justify-center ">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
												<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd"/>
											</svg>
										</p>
									</div>
									<div className={"!hidden grid-cols-[0.7fr_1fr_1fr] mb-2 bg-white dark:text-white dark:bg-gray-700 p-4 justify-between items-center w-full"}>
										<div>
						          <span className="text-[15px] font-bold text-left ">
						            {i18next.t("Bank transfer payment options")}
						          </span>
										</div>
										<p className="text-xl font-bold flex justify-center "></p>
										<p className="text-xl font-bold flex justify-center ">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
												<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd"/>
											</svg>
										</p>
									</div>
									<div className={"grid grid-cols-[0.7fr_1fr_1fr] mb-2 p-4 dark:text-white justify-between items-center w-full"}>
										<div>
											<p className="text-[15px] font-bold text-left ">
												{i18next.t("Dedicated account manager")}
											</p>
										</div>
										<p className="text-xl font-bold flex justify-center "></p>
										<p className="text-xl font-bold flex justify-center ">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
												<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd"/>
											</svg>
										</p>
									</div>
								</div>
							</div>
						</div>
					}
				</div>

				<div className="max-w-full h-auto relative px-4">
					<div className="flex flex-col items-start gap-10">
						<div className="rounded-[7px] p-2.5">
							<p className="text-2xl md:text-3xl lg:text-4xl font-medium text-gray-950 dark:text-white">
								{i18next.t("Frequently Asked Questions")}
							</p>
						</div>
						<div className="flex flex-col w-full gap-8">
							{[
								{
									number: "01",
									question: i18next.t("Can I try ClipSymphony for free"),
									answer: i18next.t("Yes Our Basic Plan is free for personal use and the Professional Plan offers a 1-month free trial")
								},
								{
									number: "02",
									question: i18next.t("How does team management work"),
									answer: i18next.t("ClipSymphony allows you to create multiple teams and workspaces You can assign different roles and permissions to each team member to ensure efficient collaboration")
								},
								{
									number: "03",
									question: i18next.t("What if a team member becomes inactive"),
									answer: i18next.t("For the Professional and Enterprise Plans we offer automatic billing stops for inactive users so you only pay for active team members")
								},
								{
									number: "04",
									question: i18next.t("Is customer support available"),
									answer: i18next.t("Absolutely We offer customer support for all our plans with priority support for Enterprise customers")
								}
							].map((faq, index) => (
								<div
									key={index}
									className={`border ${this.state.activeFaq === faq.number ? "bg-clip text-gray-100" : "dark:text-gray-200 text-gray-950"} border-[#191a23] dark:border-gray-200 w-full rounded-[45px] p-6 md:p-10 shadow-md`}
								>
									<div className="flex justify-between items-center mb-4">
										<div className="flex items-center gap-4">
											<p className="text-3xl md:text-4xl font-medium">{faq.number}</p>
											<p className="text-xl break-all md:text-2xl lg:text-3xl font-medium">
												{faq.question}
											</p>
										</div>
										<div
											className="flex items-center justify-center px-3 sm:px-0 w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full hover:bg-gray-300 transition-colors duration-200">
											{this.state.activeFaq === faq.number ? <MinusIcon onClick={() => {
													this.setState({activeFaq: ""})
												}} className="w-6 h-6 cursor-pointer dark:text-gray-200 text-gray-800"/> :
												<PlusIcon onClick={() => {
													this.setState({activeFaq: faq.number})
												}} className="w-6 h-6 cursor-pointer dark:text-gray-200 text-gray-800"/>}
										</div>
									</div>
									<div className={`${this.state.activeFaq === faq.number ? "" : "hidden"}`}>
										<hr className={`border-t border-black dark:border-white mb-4`}/>
										<p className="text-base md:text-lg">{faq.answer}</p>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>

				<div className="flex flex-col my-28 w-full px-4 md:px-0">
					<div className="flex flex-col justify-start items-start">
						<div className="flex flex-col justify-start items-start gap-2.5 py-4 text-gray-800 dark:text-white">
							<p className="text-2xl md:text-4xl font-medium text-left dark:!text-white">
								{i18next.t("Ready to Elevate Your Media Management")}
							</p>
						</div>
					</div>
					<div className="w-full md:w-[50%] mt-6">
						<p className="text-lg md:text-xl text-left dark:!text-gray-300">
							{i18next.t("Join the ranks of industry leaders who trust ClipSymphony for their media needs Simplify your workflow and unleash your teams full potential")}
						</p>
						<div className="flex justify-start items-center mt-6 gap-2.5 py-5 rounded-lg">
							<p className="text-xl text-center">
								<button className="px-8 py-3 rounded-lg shadow-xl text-2xl text-white bg-clip-blue">
									<a href="/app/signup">{i18next.t("Get Started Today")}</a>
								</button>
							</p>
						</div>
					</div>
				</div>

				<div className="flex flex-col my-28 w-full px-4 md:px-0">
					<div className="flex flex-col justify-start items-start">
						<div
							className="flex flex-col justify-start items-start gap-2.5 p-4 text-gray-800 dark:text-white">
							<p className="text-2xl md:text-4xl font-medium text-left  dark:!text-white">
								{i18next.t("Contact Us")}
							</p>
						</div>
					</div>
				</div>

				<div>
					<ContactPage language={"en"}/>
				</div>

			</div>
		);
	}
}

